{
  "book": {
    "brand": "Smart Word Labs",
    "breadcrumb": "Reservar una evaluación gratuita",
    "errors": {
      "generic": "No se pudo reservar tu evaluación"
    },
    "success": {
      "title": "¡Evaluación reservada!",
      "body": "Revisa tu correo electrónico para ver la confirmación y los datos de acceso. Hemos enviado un enlace de inicio de sesión seguro a",
      "bodyEnd": "para que puedas acceder a tu portal de padres sin contraseña.",
      "backHome": "Volver al inicio"
    },
    "form": {
      "title": "Reserva tu evaluación gratuita",
      "subtitle": "Tarda menos de un minuto. No necesitas cuenta ni datos de pago: nosotros configuraremos tu portal de padres.",
      "parentName": "Nombre del padre/madre",
      "parentEmail": "Correo electrónico del padre/madre",
      "childName": "Nombre del niño/a",
      "childAge": "Edad del niño/a",
      "date": "Fecha preferida",
      "time": "Hora preferida",
      "booking": "Reservando…",
      "submit": "Reservar evaluación gratuita",
      "alreadyEnrolled": "¿Ya estás inscrito?",
      "parentSignIn": "Inicio de sesión de padres",
      "localTimeNote": "Horarios en tu zona horaria"
    }
  },
  "checkout": {
    "title": "Pago seguro",
    "summary": "{{name}} — ${{monthly}} al mes, {{lessons}}. Cancela cuando quieras.",
    "couldNotStart": "No se pudo iniciar el pago",
    "choosePlan": {
      "before": "Elige un plan en la",
      "link": "página de precios",
      "after": "para continuar."
    },
    "summaryOneTime": "{{name}} — {{monthly}} USD pago único, {{lessons}}."
  },
  "contact": {
    "breadcrumb": "Contáctanos",
    "title": "Contáctanos",
    "subtitle": "Usa el formulario a continuación y te responderemos personalmente dentro de un día hábil.",
    "eyebrow": "Habla con nosotros",
    "heading": "¿Preguntas sobre el inglés de tu hijo/a?",
    "description": "Envía un mensaje y la Sra. Salma te responderá personalmente. Comparte tu número de WhatsApp si prefieres una nota de voz rápida o una llamada en lugar de un correo electrónico.",
    "bullets": {
      "email": "Respondemos por correo electrónico dentro de un día hábil (lunes a sábado).",
      "whatsapp": "¿Prefieres WhatsApp? Agrega tu número y te escribiremos ahí."
    },
    "form": {
      "name": "Nombre del padre/madre",
      "email": "Correo electrónico",
      "whatsapp": "Número de WhatsApp (opcional)",
      "dialCodeAria": "Código de marcación del país",
      "whatsappPlaceholder": "300 1234567",
      "childAge": "Edad del niño/a (opcional)",
      "childAgePlaceholder": "p. ej. 7",
      "subject": "Asunto (opcional)",
      "subjectPlaceholder": "Horarios de clases, precios, evaluación…",
      "message": "Mensaje",
      "sending": "Enviando…",
      "pleaseWait": "Espera {{seconds}}s…",
      "send": "Enviar mensaje",
      "sentTitle": "Mensaje recibido",
      "sentBody": "Gracias — tenemos tus datos y nos pondremos en contacto pronto.",
      "sendAnother": "Enviar otro mensaje",
      "privacyBefore": "Usamos tus datos solo para responder a esta consulta. Consulta nuestro",
      "privacyLink": "aviso de privacidad",
      "success": "Mensaje enviado — responderemos dentro de un día hábil.",
      "validation": {
        "nameRequired": "Por favor, introduce tu nombre",
        "emailInvalid": "Por favor, introduce una dirección de correo válida",
        "whatsappTooLong": "El número de WhatsApp es demasiado largo",
        "whatsappFormat": "Usa solo dígitos, espacios, + o -",
        "messageTooShort": "Cuéntanos un poco más"
      },
      "errors": {
        "tooFast": "¡Eso fue rápido! Tómate un momento e inténtalo de nuevo.",
        "checkForm": "Por favor, revisa el formulario",
        "captcha": "No pudimos verificar este envío. Por favor, inténtalo de nuevo.",
        "sendFailed": "No pudimos enviar tu mensaje. Por favor, inténtalo de nuevo."
      }
    }
  },
  "howItWorks": {
    "breadcrumb": "Cómo funciona",
    "hero": {
      "title": "Cómo funcionan nuestras clases de inglés en línea",
      "subtitle": "Grupos pequeños. Gran confianza al hablar. Cada niño es evaluado, ubicado y monitoreado según los estándares del MCER (CEFR), y luego recibe clases en vivo en un grupo de no más de cinco."
    },
    "pillars": {
      "title": "Nuestros tres principios de enseñanza"
    },
    "steps": {
      "title": "Desde la consulta hasta la primera clase"
    },
    "cta": {
      "book": "Reservar evaluación gratuita",
      "browsePrograms": "Explorar programas por edad",
      "seePricing": "Ver precios"
    }
  },
  "pricing": {
    "breadcrumb": "Precios",
    "compareLink": "¿No estás seguro de qué nivel elegir? Compara los programas"
  },
  "paymentBanner": {
    "notConfigured": "El pago en producción aún no está configurado. Completa la activación de pagos para aceptar pagos reales.",
    "testMode": "Todos los pagos realizados en la vista previa están en modo de prueba.",
    "testModeLink": "Ver documentación del modo de prueba de pagos",
    "notReady": "Los pagos en vivo aún no están completamente listos: {{failures}}. Volviendo a comprobar automáticamente."
  },
  "faq": {
    "title": "Preguntas frecuentes de los padres",
    "subtitle": "Evaluación gratuita, tecnología, horarios, pagos, ubicación y reembolsos, respondidas en detalle.",
    "items": [
      {
        "q": "¿La evaluación gratuita es realmente gratuita, y qué sucede en ella?",
        "a": "Sí — la primera sesión es una evaluación completamente gratuita de 20 a 30 minutos con la Sra. Salma, sin necesidad de datos de tarjeta. Tu hijo/a conversa, lee y realiza una breve tarea de expresión oral mientras ella evalúa su nivel según el MCER. Dentro de un día hábil recibirás un plan de aprendizaje por escrito y un grupo recomendado. No hay obligación de inscribirse después."
      },
      {
        "q": "¿Qué equipo y velocidad de internet necesitamos?",
        "a": "Basta con una laptop, computadora de escritorio o tableta con cámara web y una conexión estable de aproximadamente 5 Mbps; las clases se realizan en el navegador a través de Zoom, así que no hay nada más que instalar. Los audífonos con micrófono marcan una gran diferencia para los niños pequeños, y un lugar tranquilo y bien iluminado les ayuda a mantenerse concentrados. Los teléfonos funcionan en caso de necesidad, pero la pantalla es demasiado pequeña para las tareas de lectura compartida."
      },
      {
        "q": "¿Cómo reprogramamos o cancelamos una clase?",
        "a": "Reprograma desde el portal de padres al menos 12 horas antes de la clase. Cada plan incluye créditos de reprogramación (2 en Starter, 4 en Intensive, ilimitados en Private). Más allá de eso, intentaremos ubicar a tu hijo/a en otro grupo del mismo nivel esa semana sin costo adicional, y si no hay nada adecuado disponible, su maestra enviará una tarea de recuperación grabada y cubrirá lo pendiente en la siguiente clase."
      },
      {
        "q": "¿Qué métodos de pago aceptan y es seguro?",
        "a": "Los planes se facturan mensualmente en USD a través de Stripe, que acepta Visa, Mastercard, American Express, Apple Pay, Google Pay y la mayoría de las redes de tarjetas locales. Nunca vemos ni almacenamos el número de tu tarjeta; todo se gestiona en el proceso de pago de Stripe, que cumple con PCI. Puedes actualizar tu tarjeta o cancelar en cualquier momento desde el portal de padres, y cancelar simplemente detiene la próxima renovación."
      },
      {
        "q": "¿Cómo se ubica a mi hijo/a en el grupo de edad y nivel correcto?",
        "a": "La ubicación se realiza primero por nivel del MCER y luego por grupo de edad, de modo que un niño seguro de seis años nunca se retrasa y un niño más callado de nueve años nunca se siente abrumado. La evaluación gratuita nos da el nivel; luego, los grupos de edad (4-6 Exploradores de Fonética Temprana, 7-9 Constructores de Alfabetización, 10-12 Comunicadores Confiados) determinan el ritmo, los materiales y la duración de la clase. Si un niño supera el nivel de su grupo a mitad del trimestre, lo cambiamos sin costo adicional."
      },
      {
        "q": "¿Cuál es su política de reembolso?",
        "a": "Si no estás satisfecho después del primer mes pagado de tu hijo/a, escríbenos dentro de los 14 días posteriores a ese primer cargo y te reembolsaremos por completo. Después de eso, cancelar detiene la próxima renovación y conservas todas las clases ya pagadas hasta el final del mes de facturación; no cobramos tarifas de cancelación. Los detalles completos están en nuestra política de reembolsos."
      },
      {
        "q": "¿Cómo sabré si mi hijo/a está progresando?",
        "a": "Cada niño/a se evalúa según los niveles MCER al inicio. Recibes un informe de progreso por escrito cada mes y, si el progreso es más lento de lo previsto, Ms. Salma ajusta el plan de aprendizaje y lo habla contigo."
      }
    ]
  },
  "faculty": {
    "title": "Conoce a tu maestra",
    "subtitle": "Cada clase es impartida por la Sra. Salma, especialista certificada en CELTA en inglés para niños, siguiendo nuestro currículo alineado con el MCER.",
    "teacher": {
      "name": "Sra. Salma",
      "credential": "Certificada en CELTA (Cambridge English) · Licenciatura en Inglés y Psicología Aplicada",
      "experience": "Más de 10 años enseñando inglés, desde primaria hasta adultos, en Canadá y Medio Oriente",
      "detail": "Alfabetización temprana y fonética del currículo británico, clases alineadas con el MCER, preparación para el IELTS y entrevistas.",
      "quote": "La fonética se aprende cuando suena a juego, no a ejercicio repetitivo.",
      "photoAlt": "Sra. Salma, profesora de inglés certificada en CELTA en Smart Word Labs"
    }
  },
  "testimonials": {
    "title": "Lo que dicen los padres sobre nuestras clases de inglés en línea",
    "ratingSummary": "4.9/5 de más de 1200 reseñas verificadas de padres",
    "starsAria": "{{rating}} de 5 estrellas",
    "prevAria": "Reseñas anteriores",
    "nextAria": "Siguientes reseñas",
    "pageAria": "Mostrar página de reseñas {{page}}",
    "reviews": [
      {
        "quote": "Aariz pasó de respuestas de una sola palabra a contarnos historias completas sobre su clase. El grupo de cuatro hace que realmente tenga que hablar, eso lo cambió todo.",
        "name": "Sana M.",
        "childAge": "Madre de un niño de 6 años",
        "location": "Dubái, EAU",
        "rating": 5
      },
      {
        "quote": "El informe mensual del MCER es lo primero que realmente muestra progreso en lugar de solo 'le va bien'. Vale cada centavo.",
        "name": "Rachel T.",
        "childAge": "Madre de una niña de 9 años",
        "location": "Londres, Reino Unido",
        "rating": 5
      },
      {
        "quote": "Mis dos hijos están en la misma cuenta y puedo ver sus clases lado a lado. Reprogramar toma diez segundos.",
        "name": "Ibrahim K.",
        "childAge": "Padre de dos hijos, de 7 y 11 años",
        "location": "Karachi, Pakistán",
        "rating": 5
      },
      {
        "quote": "Literacy Builders convirtió la lectura de una lucha en algo que ella pide. Su escritura en la escuela subió un nivel completo en un trimestre.",
        "name": "Priya N.",
        "childAge": "Madre de una niña de 8 años",
        "location": "Singapur",
        "rating": 5
      },
      {
        "quote": "Confident Communicators es exactamente lo que nuestro hijo necesitaba antes de la secundaria; ahora presenta un argumento en la mesa de la cena sin pestañear.",
        "name": "Marco B.",
        "childAge": "Padre de un niño de 11 años",
        "location": "Milán, Italia",
        "rating": 5
      },
      {
        "quote": "Las clases de Early Phonics duran solo 30 minutos, lo cual es perfecto para la capacidad de atención de un niño de cinco años. Ahora deletrea palabras a donde quiera que vamos.",
        "name": "Hannah L.",
        "childAge": "Madre de un niño de 5 años",
        "location": "Mánchester, Reino Unido",
        "rating": 5
      },
      {
        "quote": "Usamos el programa de preparación para entrevistas antes de las evaluaciones de admisión. Nuestra hija entró genuinamente relajada y obtuvo su primera opción.",
        "name": "Elena V.",
        "childAge": "Madre de una niña de 10 años",
        "location": "Madrid, España",
        "rating": 5
      },
      {
        "quote": "La Sra. Salma notó en solo dos clases que mi hijo estaba adivinando en lugar de decodificar. Nadie en la escuela lo había detectado en un año.",
        "name": "Yusuf A.",
        "childAge": "Padre de un niño de 7 años",
        "location": "Doha, Catar",
        "rating": 5
      },
      {
        "quote": "La evaluación gratuita por sí sola fue más útil que las pruebas pagadas que hicimos en otro lugar. Nos inscribimos la misma semana y no hemos mirado atrás.",
        "name": "Claire D.",
        "childAge": "Madre de una niña de 9 años",
        "location": "Toronto, Canadá",
        "rating": 4
      }
    ]
  },
  "placementQuiz": {
    "eyebrow": "Ubicación en 30 segundos",
    "title": "Encuentra el grupo adecuado en 30 segundos",
    "subtitle": "Tres preguntas rápidas y te dirigiremos al programa que se adapta a tu hijo/a.",
    "stepOf": "Paso {{current}} de {{total}}",
    "back": "← Atrás",
    "recommended": "Programa recomendado",
    "bookCta": "Reserva tu evaluación gratuita",
    "seeFullProgramme": "Ver el programa completo",
    "startAgain": "Empezar de nuevo",
    "reasons": {
      "new": "Empezaremos con sonidos y respuestas orales cortas para que tu hijo/a gane confianza antes de acelerar el ritmo.",
      "confident": "Tu hijo/a está listo/a para turnos de conversación más largos, así que las clases enfatizan la estructura, el vocabulario y la argumentación.",
      "default": "Las clases equilibran la práctica guiada con mucho tiempo de expresión oral independiente."
    },
    "steps": [
      {
        "key": "age",
        "title": "¿Qué edad tiene tu hijo/a?",
        "options": [
          {
            "value": "4-6",
            "label": "4–6 años"
          },
          {
            "value": "7-9",
            "label": "7–9 años"
          },
          {
            "value": "10-12",
            "label": "10–12 años"
          }
        ]
      },
      {
        "key": "goal",
        "title": "¿Qué es lo más importante ahora mismo?",
        "options": [
          {
            "value": "phonics",
            "label": "Lectura y fonética"
          },
          {
            "value": "writing",
            "label": "Escritura y trabajo escolar"
          },
          {
            "value": "speaking",
            "label": "Confianza al hablar"
          },
          {
            "value": "exams",
            "label": "Exámenes y entrevistas"
          }
        ]
      },
      {
        "key": "comfort",
        "title": "¿Qué tan cómodo/a se siente tu hijo/a hablando inglés?",
        "options": [
          {
            "value": "new",
            "label": "Recién empezando"
          },
          {
            "value": "some",
            "label": "Algunas oraciones"
          },
          {
            "value": "confident",
            "label": "Conversa con bastante soltura"
          }
        ]
      }
    ]
  },
  "cohortTimeConverter": {
    "intro": "Ms. Salma enseña desde Toronto. Horarios de clase en tu zona horaria:",
    "timezoneLabel": "Tu zona horaria",
    "timezonePlaceholder": "Selecciona tu zona horaria",
    "footnote": "Horarios mostrados en tu hora local. Tu horario exacto se confirma durante la evaluación gratuita."
  }
}
